// Preprod pick: AWL-2671: AKASHGO-APP-LAUNCH event and first-time/logged-in props.
import { setLoginManual } from '@containers/Login/APIs/actions';
import { SUBSCRIPTION_STATUS } from '@containers/Subscription/APIs/constant';
import { getAnalyticsSource, getSearchParam, isHelpCenterWebView, isMobile, isUserloggedIn } from '@utils/common';
import { LOCALSTORAGE } from '@utils/constants';
import MIXPANEL from '@utils/constants/mixpanel';
import MOENGAGE from '@utils/constants/moengage';
import mixPanelConfig from '@utils/mixpanel';
import moengageConfig from '@utils/moengage';
import { getKey, setKey } from '@utils/storage';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { fetchMixpanelId } from '@src/action';
import { URL } from '@utils/constants/routeConstants';

export default function useMixpanel() {
  const [distinctId, setDistinctId] = useState();
  
  const location = useLocation();

  const dispatch = useDispatch();

  const loggedStatus = useSelector(state => state.commonContent?.loggedStatus);
  const isManualLogin = useSelector( state => state.loginReducer?.isManualLogin);
  const loginSource = useSelector( state => state.loginReducer.loginSource );
  const subscriptionStatus = useSelector( state => state.subscriptionDetails?.currentSubscription?.data?.subscriptionStatus);

  const initialMount = useRef(true);

  /** Handle When user manually logs in */
  useEffect(()=>{
    if(loggedStatus && isManualLogin && !initialMount.current){
        setUserProperties();
        triggerLoginEvent();
    }
  },[loggedStatus, isManualLogin])

  /** Handle when user logs out */
  useEffect(()=>{
    if(!loggedStatus && !initialMount.current){
        mixPanelConfig.resetUserType();
    }
  },[loggedStatus])

  /** Handle on mount */
  useEffect(()=>{
    const token = getSearchParam('token');
    let helpCenterToken = getKey(LOCALSTORAGE.HELP_CENTER_TOKEN);
    initialMount.current = false;
    if(isMobile.any() && token && window.location.pathname.includes( URL.HELP_CENTER )){
      // do nothing if user redirected from app to helpcenter 
      if(token !== helpCenterToken?.slice(7))
      return;
    }
    const initializeMixpanel = async () => {
      await setUserProperties();
      trackAppLaunchEvent();
    };
    initializeMixpanel();
  },[])

  const triggerLoginEvent  = () => {
    if(!isHelpCenterWebView()){
      let mixpanel = {
          [`${MIXPANEL.PARAMETER.USER_STATE}`]: subscriptionStatus === SUBSCRIPTION_STATUS.ACTIVE ? MIXPANEL.VALUE.SUBSCRIBED: MIXPANEL.VALUE.FREEMIUM,
          [`${MIXPANEL.PARAMETER.SOURCE}`]: loginSource || '',
      }
      loginSource === MIXPANEL.VALUE.DISCOUNTING_PAGE && ( mixpanel = {...mixpanel,...{[`${MIXPANEL.PARAMETER.PAGE_NAME}`]: loginSource || '',}})
      mixPanelConfig.trackEvent(MIXPANEL.EVENT.LOGIN_SUCCESS, mixpanel);
    }
    dispatch(setLoginManual(false))
  }

  const trackAppLaunchEvent = () => {
    if (!isHelpCenterWebView()) {
      const isFirstAppLaunch = !getKey(LOCALSTORAGE.AKASHGO_APP_LAUNCH_TRACKED);
      if (isFirstAppLaunch) {
        setKey(LOCALSTORAGE.AKASHGO_APP_LAUNCH_TRACKED, true);
      }

      mixPanelConfig.trackEvent(MIXPANEL.EVENT.APP_LAUNCH, {
        [MIXPANEL.PARAMETER.FIRST_TIME]: isFirstAppLaunch
          ? MIXPANEL.VALUE.CAPITALIZED_YES
          : MIXPANEL.VALUE.CAPITALIZED_NO,
        [MIXPANEL.PARAMETER.LOGGED_IN_STATE]: isUserloggedIn()
          ? MIXPANEL.VALUE.CAPITALIZED_YES
          : MIXPANEL.VALUE.CAPITALIZED_NO,
        [MIXPANEL.PARAMETER.TIME_STAMP]: moment().format("MMM D, YYYY"),
      });
    }
  }

  const setUserProperties = async () => {
    let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
    if(isUserloggedIn() && !userInfo?.mixpanelId){
      await dispatch(fetchMixpanelId());
    }
    // Call identify first so it always runs even if people/super setup throws.
    const uniqueId = mixPanelConfig.identifyUser();
    mixPanelConfig.setSuperProperties();
    mixPanelConfig.setGroup();
    mixPanelConfig.setGroupProperties();
    mixPanelConfig.setPeopleProperties();
    moengageConfig.setUserAttributes(uniqueId);
    setDistinctId(uniqueId);
    return userInfo;
  }
  
  return distinctId;
}
